module.exports = __webpack_public_path__ + "static/img/open-title-3.13fea54e.png";